module.exports = __webpack_public_path__ + "static/media/mdwa.e76431cd.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/mdwa.ttf?62057485
// module id = 46
// module chunks = 0